export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  header: "nav-header",
  logo: "nav-logo",
  ctaButton: "nav-cta-button",
  loginButton: "nav-login-button",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const STORY = {
  generatorSection: "story-generator-section",
  form: "story-generator-form",
  childNameInput: "child-name-input",
  ageSelect: "age-select",
  themeSelect: "theme-select",
  companionInput: "companion-input",
  generateButton: "generate-story-button",
  storyDisplay: "story-display",
  storyTitle: "story-title",
  storyText: "story-text",
  illustrationCard: "illustration-card",
  generateIllBtn: "generate-illustration-btn",
  generateAllBtn: "generate-all-illustrations-btn",
  batchProgress: "illustration-batch-progress",
};

export const VOICE = {
  playerSection: "narration-player-section",
  voiceCard: "voice-card",
  playPauseButton: "play-pause-button",
  generateNarrationBtn: "generate-narration-btn",
  volumeSlider: "volume-slider",
  previewButton: "voice-preview-button",
};

export const PRICING = {
  section: "pricing-section",
  freeCard: "pricing-free-card",
  premiumCard: "pricing-premium-card",
  familyCard: "pricing-family-card",
  subscribeMonthlyBtn: "subscribe-monthly-btn",
  subscribeYearlyBtn: "subscribe-yearly-btn",
  subscribeFamilyMonthlyBtn: "subscribe-family-monthly-btn",
  subscribeFamilyYearlyBtn: "subscribe-family-yearly-btn",
  paypalButtons: "paypal-buttons-container",
};

export const LIBRARY = {
  page: "library-page",
  storyGrid: "library-story-grid",
  storyCard: "library-story-card",
  emptyState: "library-empty-state",
  profileChip: "profile-chip",
  addProfileBtn: "add-profile-btn",
  profileForm: "profile-form",
  profileNameInput: "profile-name-input",
  profileSaveBtn: "profile-save-btn",
  profileDeleteBtn: "profile-delete-btn",
};

export const READER = {
  page: "reader-page",
  title: "reader-story-title",
  backBtn: "reader-back-btn",
  pdfBtn: "download-pdf-btn",
};

export const AUTH = {
  modal: "auth-modal",
  nameInput: "auth-name-input",
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  submitButton: "auth-submit-button",
  toggleLink: "auth-toggle-link",
  closeButton: "auth-close-button",
  googleButton: "auth-google-button",
};
